module.exports = __webpack_public_path__ + "static/media/公众号二维码.ac2dc56e.jpg";